import { render, staticRenderFns } from "./RestoreAvenantsModal.vue?vue&type=template&id=67eed65c"
import script from "./RestoreAvenantsModal.vue?vue&type=script&lang=ts"
export * from "./RestoreAvenantsModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports